import { BNBackgroundEffect, BNBox } from "@bn-monorepo/js-packages";
import { ReactNode } from "react";

interface Props {
  hydrationReady: boolean;
  children: ReactNode;
}

const CmsContentWrapper: React.FC<Props> = ({ hydrationReady, children }) => (
  <BNBox
    sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
    }}
    data-uit-hydration={hydrationReady ? 1 : 0}
  >
    <BNBackgroundEffect />
    {children}
  </BNBox>
);

export default CmsContentWrapper;
